import map from "lodash/map"
import get from "lodash/get"
import { withLocalization } from "hoc-lib/localization"
import Box from "component-lib/Base/components/Box"
import { ButtonPrimary } from "../../../../Base"
import FacilityDetails from "../FacilityDetails/FacilityDetailsContainer"
import FacilityListItem from "./FacilityListItem/FacilityListItemContainer"
import "./FacilitySearchResults.scss"

const _map = map.bind(map)

const DROP_OFF_WASTE = `drop_off_waste`

export const strings = {
  en_CA: {
    CUSTOMER_SERVICE: `Customer Service`,
    SALES: `Sales`,
    ACCEPTED: `Accepted non-hazardous materials:`,
    GET_DIRECTIONS: `Directions`,
    DETAILS: `Details`,
    ACCEPTED_MATERIALS: `Accepted Materials`,
    HOURS: `Hours`,
    HOLIDAYS: `Holidays`,
    VISIT_WEBSITE: `Visit Website`,
    LIST: `List`,
    MONDAY: `Monday`,
    TUESDAY: `Tuesday`,
    WEDNESDAY: `Wednesday`,
    THURSDAY: `Thursday`,
    FRIDAY: `Friday`,
    SATURDAY: `Saturday`,
    SUNDAY: `Sunday`,
    NONHAZARDOUS: `Non-Hazardous`,
    HAZARDOUS: `Hazardous`,
  },
  fr_CA: {
    CUSTOMER_SERVICE: `Service à la clientèle`,
    SALES: `Ventes`,
    ACCEPTED: `Matières non dangereuses acceptées:`,
    GET_DIRECTIONS: `L'itinéraire`,
    DETAILS: `Détails`,
    ACCEPTED_MATERIALS: `Matériaux acceptés`,
    HOURS: `Heures D'Ouverture`,
    HOLIDAYS: `Jour Fériés`,
    VISIT_WEBSITE: `Visiter le Site Internet`,
    LIST: `List`, // translate: true
    MONDAY: `lundi`,
    TUESDAY: `mardi`,
    WEDNESDAY: `mercredi`,
    THURSDAY: `jeudi`,
    FRIDAY: `vendredi`,
    SATURDAY: `samedi`,
    SUNDAY: `dimanche`,
    NONHAZARDOUS: `non dangereuses`,
    HAZARDOUS: `dangereuses`,
  },
}

const FacilitySearchResultsUnwrapped = ({
  onSelectFacility,
  onMouseEnterItem = () => {},
  onMouseLeaveItem = () => {},
  isAccordionItem = false,
  map,
  strings,
  dropoffType,
  facilityDetailsProps,
  setListStatus,
}) => {
  const [showList, setShowList] = setListStatus
  function renderResults() {
    // facTypeCode:
    //   2 = Landfill
    //   3 = Recycling Center
    //   4 = Transfer Station
    const isWaste = dropoffType === DROP_OFF_WASTE

    // store the matched facilities into mapLocations
    // _.get() will return the list of map locations near the entered address
    // .filter() will filter that list of map locations
    //   for the ones that match the facility type the user selected
    const mapLocations = get(map, `mapLocations`, []).filter(
      // loc - the current element being checked
      (loc) => {
        const currentFacTypeCode = get(loc, `properties.facTypeCode`, ``)
        return isWaste
          ? currentFacTypeCode === `2` || currentFacTypeCode === `4`
          : currentFacTypeCode === `3`
      },
    )

    return _map(mapLocations, (item, count) => {
      const itemProps = {
        strings,
        map,
        item,
        onSelectFacility,
        onMouseEnterItem,
        onMouseLeaveItem,
        isAccordionItem,
      }
      return (
        <FacilityListItem key={`item.properties.Id${count}`} {...itemProps} />
      )
    })
  }

  return (
    <Box
      data-testid="FacilitySearchResults"
      className={`FacilitySearchResults ${
        showList || map.selectedFacilityId !== null ? `` : `hide-list`
      }`}
    >
      <Box className="mobile-result-toggle">
        {map.selectedFacilityId === null && (
          <ButtonPrimary onClick={() => setShowList(!showList)}>
            {strings.LIST}
          </ButtonPrimary>
        )}
      </Box>
      <Box className="results-wrapper">
        {map.selectedFacilityId !== null ? (
          <FacilityDetails
            useFullPane
            strings={strings}
            {...facilityDetailsProps}
          />
        ) : (
          renderResults()
        )}
      </Box>
    </Box>
  )
}

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// FacilitySearchResultsUnwrapped.propTypes = {
//   onSelectFacility: PropTypes.func.isRequired,
//   onMouseEnterItem: PropTypes.func,
//   onMouseLeaveItem: PropTypes.func,
//   isAccordionItem: PropTypes.bool,
//   map: PropTypes.object.isRequired,
//   strings: PropTypes.object.isRequired,
//   dropoffType: PropTypes.string.isRequired,
//   facilityDetailsProps: PropTypes.string.isRequired,
//   setListStatus: PropTypes.func.isRequired,
// }

// Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// FacilitySearchResultsUnwrapped.defaultProps = {
//   onMouseEnterItem: () => {},
//   onMouseLeaveItem: () => {},
//   isAccordionItem: false,
// }

export const FacilitySearchResults = withLocalization(strings)(
  FacilitySearchResultsUnwrapped,
)
